import { cn } from '@/lib/utils'

interface DashboardLoadingIconProps {
  className?: string
}
export default function DashboardLoadingIcon({ className = '' }: DashboardLoadingIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      className={cn('h-4 w-4 animate-spin text-brand-primary', className)}
    >
      <path
        d="M64 32C64 24.8122 61.5801 17.8337 57.1301 12.189C52.6802 6.54429 46.4595 2.56212 39.4703 0.884163C32.481 -0.793797 25.1304 -0.0698268 18.6029 2.93942C12.0753 5.94866 6.75099 11.0679 3.48779 17.4723C0.224597 23.8767 -0.7874 31.1932 0.61487 38.2429C2.01714 45.2926 5.75201 51.6649 11.2177 56.333C16.6833 61.0011 23.5614 63.6931 30.7437 63.9753C37.9259 64.2575 44.9941 62.1134 50.8091 57.8885L47.0473 52.7108C42.3953 56.0907 36.7408 57.806 30.9949 57.5803C25.2491 57.3545 19.7466 55.2009 15.3741 51.4664C11.0016 47.7319 8.01371 42.6341 6.8919 36.9943C5.77008 31.3546 6.57968 25.5013 9.19023 20.3778C11.8008 15.2543 16.0603 11.1589 21.2823 8.75153C26.5044 6.34414 32.3848 5.76496 37.9762 7.10733C43.5676 8.4497 48.5442 11.6354 52.1041 16.1512C55.6641 20.667 57.6 26.2498 57.6 32H64Z"
        fill="currentColor"
      />
    </svg>
  )
}
